import { render, staticRenderFns } from "./trialBalanceList.vue?vue&type=template&id=680bb2ff"
import script from "./trialBalanceList.vue?vue&type=script&lang=js"
export * from "./trialBalanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports